import React, { SyntheticEvent, useRef, useState, useEffect } from 'react';
import { Formik, Form, ErrorMessage, FieldArray, Field } from 'formik';
import { appointmentFormSchema, newappointmentFormSchema } from '@custom/Utils/schema/schema';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _commonUrls } from '@custom/Utils/constants/apiUrls';
import { AppDispatch, RootState } from '../../store/store';
import addEditAppointment from '@custom/rtk-apis/appointment/addEditAppointment';
import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from '@custom/store/slices/Appointment/addEditAppointmentSlice';
import latestModality from '@custom/rtk-apis/appointment/latestModality';
import { closeLatestModal } from '@custom/store/slices/Appointment/latestModalitySlice';
import { servicesManager } from '../../../app/src/App';
import { Loader, SuccessModal } from '@ohif/ui';
import { customStyle, getCurrencyContact } from '@custom/Utils/utils';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useTheme } from "../../../ui/src/contextProviders"
import { Autocomplete, Chip, TextField, Tooltip } from '@mui/material';
import SortIcon from '@mui/icons-material/Sort';
import getPackage from '@custom/rtk-apis/billing/getBilling';
import getInvestigationApi from '@custom/rtk-apis/billing/getInvestigation';
import addInvoiceApi from '@custom/rtk-apis/billing/invoice/addInvoice';
import getConsultationCharges from '@custom/rtk-apis/billing/consultation/getConsultationCharges';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import getPrice from '@custom/rtk-apis/price/getPrice';
import getBillingGeneralSettings from '@custom/rtk-apis/billing/getGeneralSettings';
import fetchActiveMachineList from '@custom/rtk-apis/activeMachine/activeMachineList';

const NewAppointment = ({ patient }) => {
  const navigate = useNavigate();
  const { uiNotificationService } = servicesManager.services;

  const dispatch = useDispatch<AppDispatch>()
  const patientDetails = patient
  const [selectedOption, setSelectedOption] = useState('No');
  const [commonData, setCommonData] = useState({ modality: [] })
  const [sameAsHomeAddress, setSameAsHomeAddress] = useState(false)
  const [state, setStates] = useState([])
  const [cities, setCities] = useState([])
  const [timeSlot, setTimeSlot] = useState([])
  const [sameAsPhoneNo, setSameAsPhoneNo] = useState(false)
  const [latestModalityStudy, setLatestModalityStudy] = useState({
    modality: "",
    studyRegion: ""
  })
  const [latestOption, setLatestOption] = useState(false)
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [priorityOptions, setPriorityOptions] = useState([]);
  const [countryCode, setCountryCode] = useState({
    billingWhatsappNumberCountryCode: "+91",
    billingPhoneNumberCountryCode: "+91",
    billingAlternateNumberCountryCode: "+91"
  });
  const now = new Date();
  // const currentDate = now.toISOString().split('T')[0]; // yyyy-mm-dd
  const currentDate = dayjs(now);
  const currentTime = now.toTimeString().split(' ')[0].substring(0, 5);;
  const [modalityList, setModalityList] = useState([])
  const [modal, setModal] = useState(false);
  const [title, setTitle] = useState('');
  const [appointmentType, setAppointmentType] = useState(
    patientDetails?.appointmentType || "investigation_with_modality"
  );
  const [sortOrder, setSortOrder] = useState('asc');
  const getInvestigationData = useSelector(
    (state: RootState) => state?.getInvestigationResponse || []
  );
  const getBillingPackageData = useSelector(
    (state: RootState) => state?.getPackageResponse || []
  );
  const billingGeneralSettingsData = useSelector((state: RootState) => state.getBillingGeneralSettingsSliceResponse);
  const urgencyData = useSelector((state: RootState) => state?.getUrgencyResponse?.result || []);
  const getPriceData = useSelector((state: RootState) => state?.getPriceSliceResponse?.result || []);
  const getConsultationChargesData = useSelector((state: RootState) => state?.getConsultationChargesResponse?.result?.data || []);
  const { data: machineList, loading: machineLoading, error: machineError, total } = useSelector((state: RootState) => state.ActiveMachinelistSliceResponse);
  const [referringDoctorData, setReferringDoctorData] = useState({});
  const [isDataAvailable, setIsDataAvailable] = useState<boolean>(true);
  const [isOpen, setIsOpen] = useState(false);
  const [invoiceId, setInvoiceId] = useState('');
  const [appLoading, setAppLoading] = useState(false);
  const [consultationCharges, setConsultationCharges] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>('+91');

  const defaultCountryCode = billingGeneralSettingsData?.status && billingGeneralSettingsData?.result?.currency ? getCurrencyContact(billingGeneralSettingsData.result.currency) : '+91';

  const [formInitialValues, setFormInitialValues] = useState({
    priority: "",
    date: currentDate,
    time: "",
    modality: "",
    studyRegion: "",
    machineName: "",
    price: "",
    consultingDoctorName: "",
    referringDoctorName: "",
    referringDoctorSpeciality: "",
    referringDoctorContactNumberCountryCode: defaultCountryCode,
    referringDoctorContactNumber: "",
    prefPaymentMethod: "",
    billingName: "",
    addressLine1: "",
    billingZipCode: "",
    billingCountry: "",
    billingState: "",
    billingCity: "",
    billingPhoneNumber: "",
    billingPhoneNumberCountryCode: defaultCountryCode,
    billingAlternateNumber: "",
    billingAlternateNumberCountryCode: defaultCountryCode,
    billingWhatsappNumberCountryCode: defaultCountryCode,
    billingWhatsappNumber: "",
    quesInfo: modalityList.map(question => ({
      _id: question.key,
      question: question.label,
      answer: " "
    }))
  })

  const modalities = Array.from(new Set(getPriceData.map(item => item.modality))).map(modality => ({
    value: modality,
    label: modality
  }));

  const getStudyRegions = (selectedModality) => {
    return getPriceData
      .filter(item => item.modality === selectedModality)
      .map(item => ({
        value: item.studyRegion,
        label: item.studyRegion
      }));
  };

  const getPriceValue = (modality, studyRegion) => {
    const item = getPriceData.find(
      item => item.modality === modality && item.studyRegion === studyRegion
    );
    return item ? item.price : "";
  };

  const sortOptions = (options) => {
    const sortedOptions = [...options];
    sortedOptions.sort((a, b) => {
      if (sortOrder === 'asc') {
        return a.localeCompare(b);
      } else {
        return b.localeCompare(a);
      }
    });
    return sortedOptions;
  };

  useEffect(() => {
    dispatch(getPrice({ modality: "", studyRegion: "" }));
    dispatch(getPackage({}));
    dispatch(getInvestigationApi());
    dispatch(getBillingGeneralSettings());
  }, [])

  useEffect(() => {
    if (billingGeneralSettingsData?.status === 'success' && billingGeneralSettingsData?.result?.currency) {
      const newCountryCode = getCurrencyContact(billingGeneralSettingsData.result.currency);
      setSelectedCountryCode(newCountryCode);
    }
  }, [billingGeneralSettingsData]);

  const investigationOptions = [
    ...(Array.isArray(getInvestigationData?.result?.data)
      ? getInvestigationData.result.data.map((item) => item["Package Name"])
      : []),
    ...(Array.isArray(getBillingPackageData?.result?.data)
      ? getBillingPackageData?.result?.data.map((item) => item.packageName)
      : [])
  ];

  function modifyPrices(inputString, discountPercentage = 0, hikePercentage = 0) {
    return inputString.replace(/\d+/g, match => {
      let originalPrice = parseInt(match, 10);
      let modifiedPrice = Math.round(originalPrice * (1 + hikePercentage / 100) * (1 - discountPercentage / 100));
      return modifiedPrice;
    });
  }

  const handleOptionChange = (event) => {
    if (event.target.value === 'Yes') {
      const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
      let obj = {
        hospitalId: hospitalId,
        uhid: patient.UHID
      }
      setLatestOption(true)
      dispatch(latestModality(obj))
    }
    else {
      setLatestOption(false)
      setLatestModalityStudy({
        modality: "",
        studyRegion: ""
      })
      setModalityList([])

    }
    setSelectedOption(event.target.value);
  };
  const handleCountryCodeChange = (e) => {
    setCountryCode(e.target.value);
  };

  const fetchStates = async (country, state, type) => {
    const response: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.statecity, body: { type: type, countryCode: country, stateCode: state }, headerType: 'json' })
    if (response?.status) {
      if (type === 'state') {
        setStates(response.result);
      }
      else {
        setCities(response.result)
      }
    }
  }

  const latestModalityData = useSelector((state: RootState) => {
    return state?.latestModalityResponse;
  });

  const getUrgencyPrice = (selectedPriority) => {
    if (!urgencyData || !selectedPriority) return 0;
    const urgencyItem = urgencyData.find(item => item.case.toLowerCase() === selectedPriority.toLowerCase());
    return urgencyItem ? urgencyItem.price : 0;
  };

  useEffect(() => {
    if (latestModalityData?.status === 'SUCCESS') {
      if (latestModalityData?.result?.appointmentDetials?.length) {
        const modalityValue = latestModalityData?.result?.appointmentDetials?.length
          ? latestModalityData?.result?.appointmentDetials[0].modality
          : '';
        const studyRegion = latestModalityData?.result?.appointmentDetials?.length
          ? latestModalityData?.result?.appointmentDetials[0].studyRegion
          : '';

        setLatestModalityStudy({
          modality: modalityValue,
          studyRegion: studyRegion
        })
        setFormInitialValues((prev) => ({
          ...prev,
          modality: modalityValue,
          studyRegion: studyRegion
        }));
        fetchModalityQuestions(modalityValue)
      }
      else {
        setLatestOption(false)
      }

      dispatch(closeLatestModal()); // Close the modal after setting the value

    }
  }, [latestModalityData, dispatch]);

  const fetchModalityQuestions = async (modality) => {
    const tempArray = [];
    commonData?.modality?.forEach((item) => {
      if (item.value === modality) {
        const currQuestion = item.question?.filter(ques => (ques?.for === "both") || (ques.for?.toLowerCase() === patientDetails?.gender?.toLowerCase()));
        setModalityList(currQuestion);

        const transformedQuestions = currQuestion.map(ques => ({
          _id: ques.key,            // _id from key
          question: ques.label,     // question from label
          answer: "",               // answer starts empty
          for: ques.for,
        }));

        tempArray.push(transformedQuestions);
        setTimeSlot(item.timeSlot)
      }
    });
    return tempArray;
  };
  const fetchCommonData = async () => {
    try {
      const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
      dispatch(getConsultationCharges());
      dispatch(fetchActiveMachineList({ limit: 30, pageNumber: 1, search: '' }));
      setCommonData(commonData?.result);
      setPriorityOptions(commonData?.result?.priorityOptions);
      setPaymentMethods(commonData?.result?.paymentMethods);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const getSelectedServicesIncluded = (selectedPackages) => {
    if (!selectedPackages || !Array.isArray(selectedPackages)) return [];

    const allPackages = [
      ...(getBillingPackageData?.result?.data || []).map(item => ({
        name: item.packageName,
        services: item.servicesIncluded
      })),
      ...(getInvestigationData?.result?.data || []).map(item => ({
        name: item["Package Name"],
        services: item["Services Included"].split(", ")
      }))
    ];

    const selectedServices = selectedPackages
      .map(packageName => {
        const pkg = allPackages.find(p => p.name === packageName);
        return pkg ? pkg.services : [];
      })
      .flat();

    return selectedServices.filter((item, index) => selectedServices.indexOf(item) === index);
  };
  useEffect(() => {
    if (getConsultationChargesData?.charges) {
      setConsultationCharges(getConsultationChargesData.charges);
    }
  }, [getConsultationChargesData]);
  useEffect(() => {
    fetchCommonData();
  }, []);
  const { msg, result, status, loading } = useSelector((state: RootState) => {
    return state?.addEditApointmentResponse;
  });
  useEffect(() => {
    if (status === 'SUCCESS') {
      setModal(true);
      setTitle(msg);
      dispatch(closeModal());
      setTimeout(() => {
        setModal(false);
        setTitle("");
      }, 500);
    } else if (status === 'ERROR') {
      uiNotificationService.show({
        title: 'Appointment',
        message: msg,
        type: 'error',
      });
      dispatch(closeModal());
    }
  }, [status]);

  const makeTime = (date, time, type) => {
    const timeArray = time.split("-")
    return type === 'startDate' ? `${date}T${timeArray[0].trim()}:00` : `${date}T${timeArray[timeArray.length - 1].trim()}:00`
  }
  const formatDate = (date, givenFormat, requiredFormat) => {
    return moment(date).format(requiredFormat);
  }
  const isDST = (a) => {
    let d = new Date(a);
    let jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
    let jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();

    if (d.getTimezoneOffset() !== Math.max(jan, jul)) {
      return true;
    } else {
      return (d.getTimezoneOffset() - jul) / 60;
    }
  }

  const convertDateIntoUTC = (date, time) => {
    const timeArray = time.split("-")
    let localDate = formatDate(date.format("YYYY-MM-DD"), null, 'YYYY-MM-DD') + ' ' + timeArray[0].trim() + ':00';
    let utcDate: any;
    let dst = isDST(date);
    if (typeof dst !== 'boolean') {
      utcDate = moment(localDate).utc().subtract(dst, 'hours').format('');
    } else {
      utcDate = moment.utc(moment(localDate)).format('');
    }
    let splitUTCDate = utcDate.split('Z');
    return splitUTCDate[0];
  }


  const handleSaveForm = async (values) => {
    const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
    const quesInfoToSubmit = values?.quesInfo?.map(({ for: _, ...rest }) => rest) || [];
    const selectedServiceIncluded = getSelectedServicesIncluded(values.serviceInvestigation);

    if ((!values?.date || !values?.time) && appointmentType !== 'only_investigation') {
      uiNotificationService.show({
        title: 'Appointment',
        message: 'Date and time must be provided.',
        type: 'error',
      });
      return;
    }

    const urgencyPrice = getUrgencyPrice(values.priority);

    let obj = {
      patientId: patient._id,
      hospitalId: hospitalId || 'q33243',
      date: values?.date,
      time: makeTime(values.date, values.time, 'startDate'),
      endTime: makeTime(values.date, values.time, 'endDate'),
      modality: values?.modality,
      doctorName: values?.consultingDoctorName,
      doctorId: 'Doc0123',
      studyRegion: values?.studyRegion,
      machineName: values?.machineName,
      price: values?.price,
      serviceInvestigation: values?.serviceInvestigation || [],
      investigationPrice: values?.investigationPrice,
      selectedServiceIncluded: selectedServiceIncluded.length > 0 ? selectedServiceIncluded : [],
      referDoctor: values?.referringDoctorName,
      referDoctorDialCode: '+91',
      referDoctorContact: values?.referringDoctorContactNumber,
      referDoctorSpec: values?.referringDoctorSpeciality,
      billingInfo: {
        billingName: values?.billingName,
        addressLine1: values?.addressLine1,
        country: values?.billingCountry,
        state: values?.billingState,
        city: values?.billingCity,
        zipCode: values?.billingZipCode,
        dialCode: values?.billingPhoneNumberCountryCode,
        mobileNo: values?.billingPhoneNumber,
        alternateMobileDialCode: values?.billingAlternateNumberCountryCode,
        alternateMobileNo: values?.billingAlternateNumber,
        whatsappNoDialCode: values?.billingWhatsappNumberCountryCode || '+91',
        whatsappNo: values?.billingWhatsappNumber,
      },
      appointmentType: appointmentType,
      priority: values?.priority,
      caseStudyPrice: urgencyPrice,
      quesInfo: quesInfoToSubmit,
    };

    const isConsultation = appointmentType === 'consultation';
    const isInvestigation = appointmentType === 'investigation_with_modality' || appointmentType === 'only_investigation';

    if (isConsultation || isInvestigation) {
      obj = {
        ...obj,
        time: makeTime(values?.date?.format('YYYY-MM-DD'), values.time, 'startDate'),
        endTime: makeTime(values?.date?.format('YYYY-MM-DD'), values.time, 'endDate'),
        convertStartDateInUTC: convertDateIntoUTC(values?.date, values?.time),
        ...(isConsultation && { doctorName: values?.consultingDoctorName }),
      };
    }

    if ((!obj.time || isNaN(new Date(obj.time).getTime())) && appointmentType !== 'only_investigation') {
      uiNotificationService.show({
        title: 'Appointment',
        message: 'Time must be a valid date.',
        type: 'error',
      });
      return;
    }

    setAppLoading(true);
    const response = await dispatch(addEditAppointment(obj));
    setAppLoading(false);

    if (response?.payload?.status !== 'SUCCESS') {
      uiNotificationService.show({
        title: 'Appointment',
        message: response?.payload?.msg || 'An error occurred.',
        type: 'error',
      });
      return;
    }

    const appointmentId = response?.payload?.result?._id;
    if (!appointmentId) {
      uiNotificationService.show({
        title: 'Invoice Creation',
        message: 'Appointment saved, but no ID returned to create invoice.',
        type: 'warning',
      });
      return;
    }

    setAppLoading(true);
    const invoiceResponse = await dispatch(addInvoiceApi({ appointmentId }));
    setAppLoading(false);

    if (invoiceResponse?.payload?.status !== 'success') {
      uiNotificationService.show({
        title: 'Invoice Creation',
        message: invoiceResponse?.payload?.msg || 'Failed to create invoice.',
        type: 'error',
      });
      return;
    }
    const newInvoiceId = invoiceResponse?.payload?.data?._id;
    setInvoiceId(newInvoiceId);
    uiNotificationService.show({
      title: 'Invoice Creation',
      message: 'Invoice generated successfully!',
      type: 'success',
    });

    setTimeout(() => {
      navigate(`/invoice/edit/${newInvoiceId}`);
    }, 800);
  };

  const isDarkMode = useTheme();

  const getModalitiesForRadiologist = (radiologistId) => {
    const radiologist = consultationCharges.find(
      (charge) => charge.radiologistName === radiologistId
    );
    return radiologist ? radiologist.consultationCharges?.map((item) => item.modality) : [];
  };

  const getPriceForRadiologistAndModality = (radiologistId, modality) => {
    const radiologist = consultationCharges?.find(
      (charge) => charge.radiologistName === radiologistId
    );
    const chargeItem = radiologist?.consultationCharges?.find(
      (item) => item.modality === modality
    );

    return chargeItem ? chargeItem.charge : "";
  };

  return (
    <>
      <div className='form form--innersec'>

        <Formik
          initialValues={formInitialValues}
          enableReinitialize={true}
          validationSchema={newappointmentFormSchema(appointmentType)}

          onSubmit={handleSaveForm}
        >
          {({
            errors,
            values,
            handleChange,
            handleBlur,
            touched,
            setFieldValue,
            setFieldTouched,
            resetForm
          }) => {
            const handleAppointmentTypeChange = (e) => {
              const newAppointmentType = e.target.value;
              setAppointmentType(newAppointmentType);

              if (appointmentType === "only_investigation" && newAppointmentType !== "only_investigation") {
                setFieldValue("serviceInvestigation", []);
                setFieldValue("investigationPrice", "");
              } else if (appointmentType === 'consultation' && newAppointmentType !== 'consultation') {
                setFieldValue("price", "");
                setFieldValue("modality", "");
                setFieldValue("consultingDoctorName", "");
              }
              if (newAppointmentType !== 'investigation_with_modality') {
                setFieldValue("quesInfo", []);
                setFieldValue("modality", "");
                setFieldValue("price", "");
              }
            };

            useEffect(() => {
              setFieldValue('referringDoctorContactNumberCountryCode', selectedCountryCode);
              setFieldValue('billingPhoneNumberCountryCode', selectedCountryCode);
              setFieldValue('billingAlternateNumberCountryCode', selectedCountryCode);
              setFieldValue('billingWhatsappNumberCountryCode', selectedCountryCode);
            }, [selectedCountryCode]);

            useEffect(() => {

              if (appointmentType === "consultation" && values.consultingDoctorName && values.modality) {
                const price = getPriceForRadiologistAndModality(values.consultingDoctorName, values.modality);
                setFieldValue("price", price);
                setFieldValue("modality", values.modality);
              }
            }, [values.consultingDoctorName, values.modality, setFieldValue, consultationCharges]);
            return (
              <Form>
                <section className='form__section'>
                  <div className='formRow formRow__2'>
                    <div className='formCol'>
                      {appointmentType !== 'consultation' && (
                        <div className='new-appointment-option mb-6'>
                          <h3>Repeat Previous Modality:</h3>
                          <div className='form__radio form__radio--gray mt-3'>
                            <div className="form__radio__option">
                              <input
                                type="radio"
                                name="Yes"
                                value="Yes"
                                className="form__radio__input"
                                checked={selectedOption === "Yes"}
                                onChange={handleOptionChange}
                              />
                              <label htmlFor="appointmentType" className="form__radio__label">Yes</label>
                            </div>
                            <div className="form__radio__option">
                              <input
                                type="radio"
                                name="No"
                                value="No"
                                className="form__radio__input"
                                checked={selectedOption === "No"}
                                onChange={handleOptionChange}
                              />
                              <label htmlFor="appointmentType" className="form__radio__label">No</label>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className='formCol'>
                      <div className="form__radio form__radio--gray">
                        <div className="form__radio__option">
                          <input
                            type="radio"
                            name="consultation"
                            value="consultation"
                            className="form__radio__input"
                            checked={appointmentType === "consultation"}
                            onChange={handleAppointmentTypeChange}
                          />
                          <label htmlFor="appointmentType" className="form__radio__label">Consultation</label>
                        </div>
                        <div className="form__radio__option">
                          <input
                            type="radio"
                            name="only_investigation"
                            value="only_investigation"
                            className="form__radio__input"
                            checked={appointmentType === "only_investigation"}
                            onChange={handleAppointmentTypeChange}
                          />
                          <label htmlFor="appointmentType" className="form__radio__label">Only Investigation</label>
                        </div>
                        <div className="form__radio__option">
                          <input
                            type="radio"
                            name="investigation_with_modality"
                            value="investigation_with_modality"
                            className="form__radio__input"
                            checked={appointmentType === "investigation_with_modality"}
                            onChange={handleAppointmentTypeChange}
                          />
                          <label htmlFor="appointmentType" className="form__radio__label">Investigation with Radiology</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {appointmentType === 'investigation_with_modality' && (
                    <>
                      <div className='formRow formRow__4'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label">
                              Priority <span className="required-asterisk">*</span>
                            </label>
                            <select
                              className="form__select form__select--sm"
                              id="priority"
                              name="priority"
                              style={customStyle.select}
                              onChange={(e) => {
                                setFieldValue('priority', e.target.value);
                              }}
                              onBlur={handleBlur}
                              value={values.priority}
                              autoComplete='off'
                            >
                              <option value="">-Select-</option>
                              {priorityOptions?.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            <ErrorMessage name="priority" component="div" className="error text-error" />
                          </div>
                        </div>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label">
                              Modality<span className="required-asterisk">*</span>
                            </label>
                            <select
                              className="form__select form__select--sm"
                              id="modality"
                              name="modality"
                              style={customStyle.select}
                              onChange={async (e) => {
                                const selectedModality = e.target.value;
                                setFieldValue('modality', selectedModality);
                                setFieldValue('studyRegion', "");
                                setFieldValue('price', "");
                                setFieldValue('time', "");
                                const questionArray = await fetchModalityQuestions(selectedModality);
                                setFieldValue("quesInfo", questionArray[0] || []);
                              }}
                              onBlur={handleBlur}
                              value={values.modality}
                              autoComplete='off'
                              disabled={latestOption}
                            >
                              <option value="">-Select-</option>
                              {modalities.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            <ErrorMessage name="modality" component="div" className="error text-error" />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label">
                              Study Region<span className="required-asterisk">*</span>
                            </label>
                            <select
                              className="form__select form__select--sm"
                              id="studyRegion"
                              name="studyRegion"
                              style={customStyle.select}
                              onChange={(e) => {
                                const selectedStudyRegion = e.target.value;
                                setFieldValue('studyRegion', selectedStudyRegion);
                                const price = getPriceValue(values.modality, selectedStudyRegion);
                                setFieldValue('price', price);
                              }}
                              onBlur={handleBlur}
                              value={values.studyRegion}
                              autoComplete='off'
                              disabled={latestOption || !values.modality}
                            >
                              <option value="">-Select-</option>
                              {getStudyRegions(values.modality).map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            <ErrorMessage name="studyRegion" component="div" className="error text-error" />
                          </div>
                        </div>
                        <div className='formRow formRow__2'>
                          <div className="formCol">
                            <div className="form__Field">
                              <label className="form__label">
                                Machine Name<span className="required-asterisk">*</span>
                              </label>
                              <select
                                id="machineName"
                                name="machineName"
                                className="form__select form__select--sm"
                                style={customStyle.select}
                                value={values.machineName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                autoComplete="off"
                                disabled={!isDataAvailable || !values.modality}
                              >
                                <option value="" disabled>-Select-</option>
                                {machineList?.length > 0 &&
                                  machineList
                                    .filter((machineGroup) => machineGroup.machineType === values.modality)
                                    .flatMap((machineGroup) => machineGroup.machines || [])
                                    .filter((machine) => machine.status === "enabled")
                                    .map((machine, idx) => (
                                      <option key={idx} value={machine.machineName}>
                                        {machine.machineName}
                                      </option>
                                    ))}
                              </select>
                              <ErrorMessage name="machineName" component="div" className="error text-error" />
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label">
                                Price<span className="required-asterisk">*</span>
                              </label>
                              <input
                                type="text"
                                id="price"
                                name="price"
                                placeholder="Price"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.price}
                                autoComplete='off'
                                disabled
                                className="form__input form__input--sm disabled-input"
                              />
                              <ErrorMessage name="price" component="div" className="error text-error" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='formRow formRow__4'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label">
                              Appointment Date<span className="required-asterisk">*</span>
                            </label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <Field name="date" style={{ width: '100%' }}>
                                {({ field }) => (
                                  <DatePicker
                                    sx={{
                                      width: '100%',
                                      '& .MuiInputBase-root': {
                                        backgroundColor: '#F6FFFF',
                                        borderRadius: '2rem',
                                      },
                                      '& .MuiInputBase-input': {
                                        padding: '10px',
                                      },
                                    }}
                                    {...field}
                                    value={field.value || null}
                                    format="DD/MM/YYYY"
                                    disabled={!isDataAvailable}
                                    onChange={(newValue) => {
                                      setFieldValue(field.name, newValue);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        error={touched.date && Boolean(errors.date)}
                                        helperText={touched > Date && errors.date}
                                      />
                                    )}
                                  />
                                )}
                              </Field>
                            </LocalizationProvider>
                            <ErrorMessage name="date" component="div" className="error text-error" />
                          </div>
                        </div>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label">
                              Appointment Time<span className="required-asterisk">*</span>
                            </label>
                            <select
                              className="form__select form__select--sm"
                              id="time"
                              name="time"
                              style={customStyle.select}
                              onChange={(e) => {
                                setFieldValue('time', e.target.value);
                              }}
                              onBlur={handleBlur}
                              value={values.time}
                              autoComplete='off'
                              disabled={!isDataAvailable}
                            >
                              <option value="">-Select-</option>
                              {timeSlot?.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            <ErrorMessage name="time" component="div" className="error text-error" />
                          </div>
                        </div>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='consultingDoctorName'>
                              Consulting Doctor
                            </label>
                            <input className="form__input form__input--sm"
                              type="text"
                              id="consultingDoctorName"
                              name="consultingDoctorName"
                              placeholder="Consulting Doctor Name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.consultingDoctorName}
                              autoComplete='off'
                            />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='referringDoctorName'>
                              Referring Doctor Name
                            </label>
                            <input className="form__input form__input--sm"
                              type="text"
                              id="referringDoctorName"
                              name="referringDoctorName"
                              placeholder="Referring Doctor Name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.referringDoctorName}
                              autoComplete='off'
                            />
                          </div>
                        </div>
                      </div>
                      <div className='formRow formRow__4'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='referringDoctorSpeciality'>
                              Referring Doctor Speciality
                            </label>
                            <input className="form__input form__input--sm"
                              type="text"
                              id="referringDoctorSpeciality"
                              name="referringDoctorSpeciality"
                              placeholder="Referring Doctor Speciality"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.referringDoctorSpeciality}
                              autoComplete='off'
                            />
                          </div>
                        </div>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='referringDoctorContactNumberCountryCode'>
                              Referring Doctor Contact Number
                            </label>
                            <div className='form__groupField form__groupField--phonenumber'>
                              <select className="form__select form__select--sm"
                                style={customStyle.select}
                                id="referringDoctorContactNumberCountryCode"
                                name="referringDoctorContactNumberCountryCode"
                                value={values.referringDoctorContactNumberCountryCode}
                                onChange={handleChange}
                              >
                                {commonData?.countryCode?.map((option) => (
                                  <option
                                    key={option}
                                    value={option}
                                    disabled={billingGeneralSettingsData?.status === 'success' && option !== selectedCountryCode}
                                  >
                                    {option}
                                  </option>
                                ))}
                              </select>
                              <input type="text"
                                className="form__input form__input--sm"
                                id="referringDoctorContactNumber"
                                name="referringDoctorContactNumber"
                                placeholder="Contact Number"
                                maxLength={10}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                  handleChange(e);
                                }}
                                pattern="[0-9]*"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.referringDoctorContactNumber}
                                autoComplete='off'
                              />
                            </div>
                          </div>
                        </div>
                        <div className="formCol">
                          <div className="form__Field">
                            <label className="form__label">Service Investigation</label>
                            <Autocomplete
                              id="serviceInvestigation"
                              multiple
                              options={sortOptions(investigationOptions || [])}
                              getOptionLabel={(option) => option || ""}
                              value={values.serviceInvestigation || []}
                              onChange={(event, newValues) => {
                                const allPackages = [
                                  ...(Array.isArray(getInvestigationData?.result?.data)
                                    ? getInvestigationData.result.data.map((item) => ({
                                      name: item["Package Name"],
                                      price: item.Price,
                                    }))
                                    : []),
                                  ...(Array.isArray(getBillingPackageData?.result?.data)
                                    ? getBillingPackageData?.result?.data.map((item) => ({
                                      name: item.packageName,
                                      price: item.packagePricing,
                                    }))
                                    : []),
                                ];

                                const selectedPackages = newValues.map((name) =>
                                  allPackages.find((pkg) => pkg.name === name)
                                ).filter(Boolean);

                                const prices = selectedPackages.map((pkg) => pkg.price).join(", ");

                                if (Object.keys(referringDoctorData).length === 0) {
                                  setFieldValue("investigationPrice", prices);
                                } else {
                                  let discountedPrice;
                                  if (referringDoctorData?.investigationDiscount === "--") {
                                    discountedPrice = modifyPrices(prices, 0, +referringDoctorData?.investigationHikePrice);
                                  } else {
                                    discountedPrice = modifyPrices(prices, +referringDoctorData?.investigationDiscount, 0);
                                  }
                                  setFieldValue("investigationPrice", discountedPrice);
                                }
                                setFieldValue("serviceInvestigation", newValues);
                              }}
                              onBlur={handleBlur}
                              style={customStyle.select}
                              disabled={!isDataAvailable}
                              popupIcon={null}
                              clearIcon={null}
                              open={isOpen}
                              onOpen={() => setIsOpen(true)}
                              onClose={(event, reason) => {
                                if (reason === "blur" || reason === "toggleInput") {
                                  setIsOpen(false);
                                }
                              }}
                              renderTags={(value, getTagProps) => {
                                const maxDisplayedTags = 1;
                                const displayedTags = value.slice(0, maxDisplayedTags);
                                const remainingTags = value.slice(maxDisplayedTags);
                                const remainingTagsCount = remainingTags.length;

                                return [
                                  ...displayedTags.map((option, index) => (
                                    <Chip
                                      key={index}
                                      label={option}
                                      {...getTagProps({ index })}
                                      style={{
                                        fontFamily: "'Poppins', sans-serif",
                                        fontSize: "14px",
                                        backgroundColor: "#e0e0e0",
                                        margin: "2px",
                                      }}
                                    />
                                  )),
                                  remainingTagsCount > 0 && (
                                    <Tooltip
                                      title={
                                        <div>
                                          {remainingTags.map((item, idx) => (
                                            <div key={idx}>{item}</div>
                                          ))}
                                        </div>
                                      }
                                      arrow
                                      placement="top"
                                    >
                                      <Chip
                                        label={`+${remainingTagsCount}...`}
                                        style={{
                                          fontFamily: "'Poppins', sans-serif",
                                          fontSize: "14px",
                                          backgroundColor: "#e0e0e0",
                                          margin: "2px",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </Tooltip>
                                  ),
                                ];
                              }}
                              renderOption={(props, option) => (
                                <li {...props} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <span>{option}</span>
                                  <SortIcon
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
                                    }}
                                    style={{ cursor: 'pointer', fontSize: '18px' }}
                                  />
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder={
                                    values.serviceInvestigation && values.serviceInvestigation.length > 0
                                      ? ""
                                      : "-Select-"
                                  }
                                  size="small"
                                  fullWidth
                                  InputProps={{
                                    ...params.InputProps,
                                    style: {
                                      color: "black",
                                      fontFamily: "'Poppins', sans-serif",
                                      fontSize: "14px",
                                      padding:
                                        values.serviceInvestigation && values.serviceInvestigation.length > 0
                                          ? "3px"
                                          : "9px",
                                      cursor: "pointer",
                                      borderRadius: '2rem',
                                    },
                                  }}
                                  sx={{
                                    "& .MuiInputBase-input::placeholder": {
                                      color: "black",
                                      opacity: 1,
                                    },
                                    "& .MuiOutlinedInput-root": {
                                      "&.Mui-focused fieldset": {
                                        borderColor: "black",
                                      },
                                      "&:hover fieldset": {
                                        borderColor: "black",
                                      },
                                    },
                                  }}
                                  className="form__select form__select--sm"
                                />
                              )}
                            />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className='form__Field'>
                            <label className="form__label" htmlFor='investigationPrice'>
                              Investigation Price
                            </label>
                            <input
                              type="text"
                              disabled
                              id="investigationPrice"
                              name="investigationPrice"
                              placeholder="Investigation Price"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.investigationPrice || ""}
                              className="form__input form__input--sm disabled-input"
                            />
                            <ErrorMessage name="investigationPrice" component="div" className="error text-error" />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {appointmentType === 'investigation_with_radiology' && (
                    <>
                      <div className='formRow formRow__4'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label">
                              Priority <span className="required-asterisk">*</span>
                            </label>
                            <select
                              className="form__select form__select--sm"
                              id="priority"
                              name="priority"
                              style={customStyle.select}
                              onChange={(e) => {
                                setFieldValue('priority', e.target.value);
                              }}
                              onBlur={handleBlur}
                              value={values.priority}
                              autoComplete='off'
                            >
                              <option value="">-Select-</option>
                              {priorityOptions?.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            <ErrorMessage name="priority" component="div" className="error text-error" />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label">
                              Appointment Date<span className="required-asterisk">*</span>
                            </label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <Field name="date" style={{ width: '100%' }}>
                                {({ field }) => (
                                  <DatePicker
                                    sx={{
                                      width: '100%',
                                      '& .MuiInputBase-root': {
                                        backgroundColor: '#F6FFFF',
                                        borderRadius: '2rem',
                                      },
                                      '& .MuiInputBase-input': {
                                        padding: '10px',
                                      },
                                    }}
                                    {...field}
                                    value={field.value || null}
                                    format="DD/MM/YYYY"
                                    disabled={!isDataAvailable}
                                    onChange={(newValue) => {
                                      setFieldValue(field.name, newValue);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        error={touched.date && Boolean(errors.date)}
                                        helperText={touched.date && errors.date}
                                      />
                                    )}
                                  />
                                )}
                              </Field>
                            </LocalizationProvider>
                            <ErrorMessage name="date" component="div" className="error text-error" />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='consultingDoctorName'>
                              Consulting Doctor
                            </label>
                            <input
                              className="form__input form__input--sm"
                              type="text"
                              id="consultingDoctorName"
                              name="consultingDoctorName"
                              placeholder="Consulting Doctor Name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.consultingDoctorName}
                              autoComplete='off'
                            />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='referringDoctorName'>
                              Referring Doctor Name
                            </label>
                            <input
                              className="form__input form__input--sm"
                              type="text"
                              id="referringDoctorName"
                              name="referringDoctorName"
                              placeholder="Referring Doctor Name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.referringDoctorName}
                              autoComplete='off'
                            />
                          </div>
                        </div>
                      </div>

                      <div className='formRow formRow__4'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='referringDoctorSpeciality'>
                              Referring Doctor Speciality
                            </label>
                            <input
                              className="form__input form__input--sm"
                              type="text"
                              id="referringDoctorSpeciality"
                              name="referringDoctorSpeciality"
                              placeholder="Referring Doctor Speciality"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.referringDoctorSpeciality}
                              autoComplete='off'
                            />
                          </div>
                        </div>
                      </div>

                      <div className='formRow formRow__3'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='referringDoctorContactNumberCountryCode'>
                              Referring Doctor Contact Number
                            </label>
                            <div className='form__groupField form__groupField--phonenumber'>
                              <select
                                className="form__select form__select--sm"
                                style={customStyle.select}
                                id="referringDoctorContactNumberCountryCode"
                                name="referringDoctorContactNumberCountryCode"
                                value={values.referringDoctorContactNumberCountryCode}
                                onChange={handleChange}
                              >
                                {commonData?.countryCode?.map((option) => (
                                  <option
                                    key={option}
                                    value={option}
                                    disabled={billingGeneralSettingsData?.status === 'success' && option !== selectedCountryCode}
                                  >
                                    {option}
                                  </option>
                                ))}
                              </select>
                              <input
                                type="text"
                                className="form__input form__input--sm"
                                id="referringDoctorContactNumber"
                                name="referringDoctorContactNumber"
                                placeholder="Contact Number"
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                  handleChange(e);
                                }}
                                pattern="[0-9]*"
                                maxLength={10}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.referringDoctorContactNumber}
                                autoComplete='off'
                              />
                            </div>
                          </div>
                        </div>

                        <div className="formCol">
                          <div className="form__Field">
                            <label className="form__label">Service Investigation</label>
                            <Autocomplete
                              id="serviceInvestigation"
                              multiple
                              options={sortOptions(investigationOptions || [])}
                              getOptionLabel={(option) => option || ""}
                              value={values.serviceInvestigation || []}
                              onChange={(event, newValues) => {
                                const allPackages = [
                                  ...(Array.isArray(getInvestigationData?.result?.data)
                                    ? getInvestigationData.result.data.map((item) => ({
                                      name: item["Package Name"],
                                      price: item.Price,
                                    }))
                                    : []),
                                  ...(Array.isArray(getBillingPackageData?.result?.data)
                                    ? getBillingPackageData?.result?.data.map((item) => ({
                                      name: item.packageName,
                                      price: item.packagePricing,
                                    }))
                                    : []),
                                ];

                                const selectedPackages = newValues.map((name) =>
                                  allPackages.find((pkg) => pkg.name === name)
                                ).filter(Boolean);

                                const prices = selectedPackages.map((pkg) => pkg.price).join(", ");

                                if (Object.keys(referringDoctorData).length === 0) {
                                  setFieldValue("investigationPrice", prices);
                                } else {
                                  let discountedPrice;
                                  if (referringDoctorData?.investigationDiscount === "--") {
                                    discountedPrice = modifyPrices(prices, 0, +referringDoctorData?.investigationHikePrice);
                                  } else {
                                    discountedPrice = modifyPrices(prices, +referringDoctorData?.investigationDiscount, 0);
                                  }
                                  setFieldValue("investigationPrice", discountedPrice);
                                }
                                setFieldValue("serviceInvestigation", newValues);
                              }}
                              onBlur={handleBlur}
                              style={customStyle.select}
                              disabled={!isDataAvailable}
                              popupIcon={null}
                              clearIcon={null}
                              open={isOpen}
                              onOpen={() => setIsOpen(true)}
                              onClose={(event, reason) => {
                                if (reason === "blur" || reason === "toggleInput") {
                                  setIsOpen(false);
                                }
                              }}
                              renderTags={(value, getTagProps) => {
                                const maxDisplayedTags = 1;
                                const displayedTags = value.slice(0, maxDisplayedTags);
                                const remainingTags = value.slice(maxDisplayedTags);
                                const remainingTagsCount = remainingTags.length;

                                return [
                                  ...displayedTags.map((option, index) => (
                                    <Chip
                                      key={index}
                                      label={option}
                                      {...getTagProps({ index })}
                                      style={{
                                        fontFamily: "'Poppins', sans-serif",
                                        fontSize: "14px",
                                        backgroundColor: "#e0e0e0",
                                        margin: "2px",
                                      }}
                                    />
                                  )),
                                  remainingTagsCount > 0 && (
                                    <Tooltip
                                      title={
                                        <div>
                                          {remainingTags.map((item, idx) => (
                                            <div key={idx}>{item}</div>
                                          ))}
                                        </div>
                                      }
                                      arrow
                                      placement="top"
                                    >
                                      <Chip
                                        label={`+${remainingTagsCount}...`}
                                        style={{
                                          fontFamily: "'Poppins', sans-serif",
                                          fontSize: "14px",
                                          backgroundColor: "#e0e0e0",
                                          margin: "2px",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </Tooltip>
                                  ),
                                ];
                              }}
                              renderOption={(props, option) => (
                                <li {...props} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <span>{option}</span>
                                  <SortIcon
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
                                    }}
                                    style={{ cursor: 'pointer', fontSize: '18px' }}
                                  />
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder={
                                    values.serviceInvestigation && values.serviceInvestigation.length > 0
                                      ? ""
                                      : "-Select-"
                                  }
                                  size="small"
                                  fullWidth
                                  InputProps={{
                                    ...params.InputProps,
                                    style: {
                                      color: "black",
                                      fontFamily: "'Poppins', sans-serif",
                                      fontSize: "14px",
                                      padding:
                                        values.serviceInvestigation && values.serviceInvestigation.length > 0
                                          ? "3px"
                                          : "9px",
                                      cursor: "pointer",
                                      borderRadius: '2rem',
                                    },
                                  }}
                                  sx={{
                                    "& .MuiInputBase-input::placeholder": {
                                      color: "black",
                                      opacity: 1,
                                    },
                                    "& .MuiOutlinedInput-root": {
                                      "&.Mui-focused fieldset": {
                                        borderColor: "black",
                                      },
                                      "&:hover fieldset": {
                                        borderColor: "black",
                                      },
                                    },
                                  }}
                                  className="form__select form__select--sm"
                                />
                              )}
                            />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className='form__Field'>
                            <label className="form__label" htmlFor='investigationPrice'>
                              Investigation Price
                            </label>
                            <input
                              type="text"
                              disabled
                              id="investigationPrice"
                              name="investigationPrice"
                              placeholder="Investigation Price"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.investigationPrice || ""}
                              className="form__input form__input--sm disabled-input"
                            />
                            <ErrorMessage name="investigationPrice" component="div" className="error text-error" />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {appointmentType === 'consultation' && (
                    <>
                      <div className='formRow formRow__4'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label">
                              Priority
                            </label>
                            <select
                              className="form__select form__select--sm"
                              id="priority"
                              name="priority"
                              style={customStyle.select}
                              onChange={(e) => {
                                setFieldValue('priority', e.target.value);
                              }}
                              onBlur={handleBlur}
                              value={values.priority}
                              autoComplete='off'
                            >
                              <option value="">-Select-</option>
                              {priorityOptions?.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            <ErrorMessage name="priority" component="div" className="error text-error" />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label">
                              Appointment Date<span className="required-asterisk">*</span>
                            </label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <Field name="date" style={{ width: '100%' }}>
                                {({ field }) => (
                                  <DatePicker
                                    sx={{
                                      width: '100%',
                                      '& .MuiInputBase-root': {
                                        backgroundColor: '#F6FFFF',
                                        borderRadius: '2rem',
                                      },
                                      '& .MuiInputBase-input': {
                                        padding: '10px',
                                      },
                                    }}
                                    {...field}
                                    value={field.value || null}
                                    format="DD/MM/YYYY"
                                    disabled={!isDataAvailable}
                                    onChange={(newValue) => {
                                      setFieldValue(field.name, newValue);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        error={touched.date && Boolean(errors.date)}
                                        helperText={touched.date && errors.date}
                                      />
                                    )}
                                  />
                                )}
                              </Field>
                            </LocalizationProvider>
                            <ErrorMessage name="date" component="div" className="error text-error" />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label">
                              Appointment Time<span className="required-asterisk">*</span>
                            </label>
                            <select
                              className="form__select form__select--sm"
                              id="time"
                              name="time"
                              style={customStyle.select}
                              onChange={(e) => {
                                setFieldValue('time', e.target.value);
                              }}
                              onBlur={handleBlur}
                              value={values.time}
                              autoComplete='off'
                              disabled={!isDataAvailable}
                            >
                              <option value="">-Select-</option>
                              {commonData?.consultationTimeslots?.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            <ErrorMessage name="time" component="div" className="error text-error" />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='referringDoctorName'>
                              Referring Doctor Name
                            </label>
                            <input
                              className="form__input form__input--sm"
                              type="text"
                              id="referringDoctorName"
                              name="referringDoctorName"
                              placeholder="Referring Doctor Name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.referringDoctorName}
                              autoComplete='off'
                            />
                          </div>
                        </div>
                      </div>

                      <div className='formRow formRow__4'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='referringDoctorSpeciality'>
                              Referring Doctor Speciality
                            </label>
                            <input
                              className="form__input form__input--sm"
                              type="text"
                              id="referringDoctorSpeciality"
                              name="referringDoctorSpeciality"
                              placeholder="Referring Doctor Speciality"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.referringDoctorSpeciality}
                              autoComplete='off'
                            />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='referringDoctorContactNumberCountryCode'>
                              Referring Doctor Contact Number
                            </label>
                            <div className='form__groupField form__groupField--phonenumber'>
                              <select
                                className="form__select form__select--sm"
                                style={customStyle.select}
                                id="referringDoctorContactNumberCountryCode"
                                name="referringDoctorContactNumberCountryCode"
                                value={values.referringDoctorContactNumberCountryCode}
                                onChange={handleChange}
                              >
                                {commonData?.countryCode?.map((option) => (
                                  <option
                                    key={option}
                                    value={option}
                                    disabled={billingGeneralSettingsData?.status === 'success' && option !== selectedCountryCode}
                                  >
                                    {option}
                                  </option>
                                ))}
                              </select>
                              <input
                                type="text"
                                className="form__input form__input--sm"
                                id="referringDoctorContactNumber"
                                name="referringDoctorContactNumber"
                                placeholder="Contact Number"
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                  handleChange(e);
                                }}
                                pattern="[0-9]*"
                                maxLength={10}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.referringDoctorContactNumber}
                                autoComplete='off'
                              />
                            </div>
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label">
                              Consulting Doctor<span className="required-asterisk">*</span>
                            </label>
                            <select
                              name="consultingDoctorName"
                              id="consultingDoctorName"
                              className="form__select form__select--sm"
                              style={customStyle.select}
                              value={values.consultingDoctorName}
                              onChange={(e) => {
                                const radiologistName = e.target.value;
                                handleChange(e);
                                setFieldValue("price", "");
                                setFieldValue("modality", "");
                              }}
                              disabled={!isDataAvailable}
                            >
                              <option value="">-Select Doctor-</option>
                              {getConsultationChargesData?.charges?.map((charge) => (
                                <option key={charge.radiologistId} value={charge.radiologistName}>
                                  {charge.radiologistName}
                                </option>
                              ))}
                            </select>
                            <ErrorMessage name="consultingDoctorName" component="div" className="error text-error" />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label">
                              Consultation Services<span className="required-asterisk">*</span>
                            </label>
                            <select
                              className="form__select form__select--sm"
                              style={customStyle.select}
                              value={values.modality || ""}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              id='modality'
                              name='modality'
                              disabled={!values?.consultingDoctorName || !isDataAvailable}
                            >
                              <option value="">-Select-</option>
                              {getModalitiesForRadiologist(values?.consultingDoctorName).map((modality) => (
                                <option key={modality} value={modality}>
                                  {modality}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className='formRow formRow__4'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='price'>
                              Price<span className='required-asterisk'>*</span>
                            </label>
                            <input
                              type="text"
                              disabled
                              id="price"
                              name="price"
                              placeholder="Price"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.price}
                              className="form__input form__input--sm disabled-input"
                            />
                            <ErrorMessage name="price" component="div" className="error text-error" />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {appointmentType === 'only_investigation' && (
                    <>
                      <div className='formRow formRow__4'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label">
                              Priority <span className="required-asterisk">*</span>
                            </label>
                            <select
                              className="form__select form__select--sm"
                              id="priority"
                              name="priority"
                              style={customStyle.select}
                              onChange={(e) => {
                                setFieldValue('priority', e.target.value);
                              }}
                              onBlur={handleBlur}
                              value={values.priority}
                              autoComplete='off'
                            >
                              <option value="">-Select-</option>
                              {priorityOptions?.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            <ErrorMessage name="priority" component="div" className="error text-error" />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='consultingDoctorName'>
                              Consulting Doctor
                            </label>
                            <input
                              className="form__input form__input--sm"
                              type="text"
                              id="consultingDoctorName"
                              name="consultingDoctorName"
                              placeholder="Consulting Doctor Name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.consultingDoctorName}
                              autoComplete='off'
                            />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='referringDoctorName'>
                              Referring Doctor Name
                            </label>
                            <input
                              className="form__input form__input--sm"
                              type="text"
                              id="referringDoctorName"
                              name="referringDoctorName"
                              placeholder="Referring Doctor Name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.referringDoctorName}
                              autoComplete='off'
                            />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='referringDoctorSpeciality'>
                              Referring Doctor Speciality
                            </label>
                            <input
                              className="form__input form__input--sm"
                              type="text"
                              id="referringDoctorSpeciality"
                              name="referringDoctorSpeciality"
                              placeholder="Referring Doctor Speciality"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.referringDoctorSpeciality}
                              autoComplete='off'
                            />
                          </div>
                        </div>
                      </div>

                      <div className='formRow formRow__3'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='referringDoctorContactNumberCountryCode'>
                              Referring Doctor Contact Number
                            </label>
                            <div className='form__groupField form__groupField--phonenumber'>
                              <select
                                className="form__select form__select--sm"
                                style={customStyle.select}
                                id="referringDoctorContactNumberCountryCode"
                                name="referringDoctorContactNumberCountryCode"
                                value={values.referringDoctorContactNumberCountryCode}
                                onChange={handleChange}
                              >
                                {commonData?.countryCode?.map((option) => (
                                  <option
                                    key={option}
                                    value={option}
                                    disabled={billingGeneralSettingsData?.status === 'success' && option !== selectedCountryCode}
                                  >
                                    {option}
                                  </option>
                                ))}
                              </select>
                              <input
                                type="text"
                                className="form__input form__input--sm"
                                id="referringDoctorContactNumber"
                                name="referringDoctorContactNumber"
                                placeholder="Contact Number"
                                maxLength={10}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                  handleChange(e);
                                }}
                                pattern="[0-9]*"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.referringDoctorContactNumber}
                                autoComplete='off'
                              />
                            </div>
                          </div>
                        </div>

                        <div className="formCol">
                          <div className="form__Field">
                            <label className="form__label">
                              Service Investigation
                              {appointmentType === 'only_investigation' && <span className="required-asterisk">*</span>}
                            </label>
                            <Autocomplete
                              id="serviceInvestigation"
                              multiple
                              options={sortOptions(investigationOptions || [])}
                              getOptionLabel={(option) => option || ""}
                              value={values.serviceInvestigation || []}
                              onChange={(event, newValues) => {
                                const allPackages = [
                                  ...(Array.isArray(getInvestigationData?.result?.data)
                                    ? getInvestigationData.result.data.map((item) => ({
                                      name: item["Package Name"],
                                      price: item.Price,
                                    }))
                                    : []),
                                  ...(Array.isArray(getBillingPackageData?.result?.data)
                                    ? getBillingPackageData?.result?.data.map((item) => ({
                                      name: item.packageName,
                                      price: item.packagePricing,
                                    }))
                                    : []),
                                ];

                                const selectedPackages = newValues.map((name) =>
                                  allPackages.find((pkg) => pkg.name === name)
                                ).filter(Boolean);

                                const prices = selectedPackages.map((pkg) => pkg.price).join(", ");

                                if (Object.keys(referringDoctorData).length === 0) {
                                  setFieldValue("investigationPrice", prices);
                                } else {
                                  let discountedPrice;
                                  if (referringDoctorData?.investigationDiscount === "--") {
                                    discountedPrice = modifyPrices(prices, 0, +referringDoctorData?.investigationHikePrice);
                                  } else {
                                    discountedPrice = modifyPrices(prices, +referringDoctorData?.investigationDiscount, 0);
                                  }
                                  setFieldValue("investigationPrice", discountedPrice);
                                }
                                setFieldValue("serviceInvestigation", newValues);
                                setFieldTouched("serviceInvestigation", true); // Mark field as touched on change
                              }}
                              onBlur={() => {
                                handleBlur({ target: { name: "serviceInvestigation" } }); // Pass correct event format
                              }}
                              style={customStyle.select}
                              disabled={!isDataAvailable}
                              popupIcon={null}
                              clearIcon={null}
                              open={isOpen}
                              onOpen={() => setIsOpen(true)}
                              onClose={(event, reason) => {
                                if (reason === "blur" || reason === "toggleInput") {
                                  setIsOpen(false);
                                }
                              }}
                              renderTags={(value, getTagProps) => {
                                const maxDisplayedTags = 1;
                                const displayedTags = value.slice(0, maxDisplayedTags);
                                const remainingTags = value.slice(maxDisplayedTags);
                                const remainingTagsCount = remainingTags.length;

                                return [
                                  ...displayedTags.map((option, index) => (
                                    <Chip
                                      key={index}
                                      label={option}
                                      {...getTagProps({ index })}
                                      style={{
                                        fontFamily: "'Poppins', sans-serif",
                                        fontSize: "14px",
                                        backgroundColor: "#e0e0e0",
                                        margin: "2px",
                                      }}
                                    />
                                  )),
                                  remainingTagsCount > 0 && (
                                    <Tooltip
                                      title={
                                        <div>
                                          {remainingTags.map((item, idx) => (
                                            <div key={idx}>{item}</div>
                                          ))}
                                        </div>
                                      }
                                      arrow
                                      placement="top"
                                    >
                                      <Chip
                                        label={`+${remainingTagsCount}...`}
                                        style={{
                                          fontFamily: "'Poppins', sans-serif",
                                          fontSize: "14px",
                                          backgroundColor: "#e0e0e0",
                                          margin: "2px",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </Tooltip>
                                  ),
                                ];
                              }}
                              renderOption={(props, option) => (
                                <li {...props} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <span>{option}</span>
                                  <SortIcon
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
                                    }}
                                    style={{ cursor: 'pointer', fontSize: '18px' }}
                                  />
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder={
                                    values.serviceInvestigation && values.serviceInvestigation.length > 0
                                      ? ""
                                      : "-Select-"
                                  }
                                  size="small"
                                  fullWidth
                                  error={touched.serviceInvestigation && Boolean(errors.serviceInvestigation)}
                                  InputProps={{
                                    ...params.InputProps,
                                    style: {
                                      color: "black",
                                      fontFamily: "'Poppins', sans-serif",
                                      fontSize: "14px",
                                      padding:
                                        values.serviceInvestigation && values.serviceInvestigation.length > 0
                                          ? "3px"
                                          : "9px",
                                      cursor: "pointer",
                                      borderRadius: '2rem',
                                    },
                                  }}
                                  sx={{
                                    "& .MuiInputBase-input::placeholder": {
                                      color: "black",
                                      opacity: 1,
                                    },
                                    "& .MuiOutlinedInput-root": {
                                      "&.Mui-focused fieldset": {
                                        borderColor: "black",
                                      },
                                      "&:hover fieldset": {
                                        borderColor: "black",
                                      },
                                    },
                                  }}
                                  className="form__select form__select--sm"
                                />
                              )}
                            />
                            <ErrorMessage name="serviceInvestigation" component="div" className="error text-error" />
                          </div>
                        </div>

                        <div className='formCol'>
                          <div className='form__Field'>
                            <label className="form__label" htmlFor='investigationPrice'>
                              Investigation Price
                            </label>
                            <input
                              type="text"
                              disabled
                              id="investigationPrice"
                              name="investigationPrice"
                              placeholder="Investigation Price"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.investigationPrice || ""}
                              className="form__input form__input--sm disabled-input"
                            />
                            <ErrorMessage name="investigationPrice" component="div" className="error text-error" />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </section>

                <section className='form__section'>
                  <h1 className='form__section__title'>Billing Information</h1>
                  <div className='formRow formRow__full'>
                    <div className='formCol'>
                      <div className="form__Field">
                        <div className="form__checkboxSubField">
                          <div className="form__checkbox">
                            <div className="form__checkbox__option m_0">
                              <input
                                className="form__checkbox__input"
                                id='sameAsHomeAddress'
                                checked={sameAsHomeAddress}
                                type="checkbox"
                                name="sameAsHomeAddress"
                                value="sameAsHomeAddress"
                                onChange={(e) => {
                                  setSameAsHomeAddress(!sameAsHomeAddress);
                                  if (sameAsHomeAddress) {
                                    values.addressLine1 = '';
                                    values.billingZipCode = '';
                                    values.billingCity = '';
                                    values.billingState = '';
                                    values.billingCountry = '';
                                    values.billingPhoneNumber = '';
                                    values.billingPhoneNumberCountryCode = selectedCountryCode;
                                    values.billingWhatsappNumber = '';
                                    values.billingWhatsappNumberCountryCode = selectedCountryCode;
                                    values.billingAlternateNumber = '';
                                    values.billingAlternateNumberCountryCode = selectedCountryCode;
                                  }
                                }}
                              />
                              <label htmlFor="sameAsHomeAddress" className="form__checkbox__label"> Same as Home Address</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='formRow formRow__4'>
                    <div className='formCol'>
                      <div className="form__Field">
                        <label className="form__label" htmlFor='billingName'>Billing Name<span className="required-asterisk">*</span></label>
                        <input
                          className="form__input form__input--sm"
                          type="text"
                          id="billingName"
                          name="billingName"
                          placeholder="Billing Name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.billingName}
                        />
                        <ErrorMessage name="billingName" component="div" className="error text-error" />
                      </div>
                    </div>
                    <div className='formCol'>
                      <div className="form__Field">
                        <label className="form__label" htmlFor='addressLine1'>Billing Address<span className="required-asterisk">*</span></label>
                        <input
                          className="form__input form__input--sm"
                          type="text"
                          id="addressLine1"
                          name="addressLine1"
                          placeholder="Billing Address"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={sameAsHomeAddress}
                          value={sameAsHomeAddress ? (values.addressLine1 = patientDetails?.contactInfo?.addressLine1) : values.addressLine1}
                        />
                        <ErrorMessage name="addressLine1" component="div" className="error text-error" />
                      </div>
                    </div>
                    <div className='formCol'>
                      <div className="form__Field">
                        <label className="form__label" htmlFor='billingPhoneNumberCountryCode'>
                          Contact Number
                        </label>
                        <div className='form__groupField form__groupField--phonenumber'>
                          <select
                            className="form__select form__select--sm"
                            style={customStyle.select}
                            id="billingPhoneNumberCountryCode"
                            onChange={handleCountryCodeChange}
                            disabled={sameAsHomeAddress}
                            value={values.billingPhoneNumberCountryCode}
                          >
                            {commonData?.countryCode?.map((option) => (
                              <option
                                key={option}
                                value={option}
                                disabled={billingGeneralSettingsData?.status === 'success' && option !== selectedCountryCode}
                              >
                                {option}
                              </option>
                            ))}
                          </select>
                          <input
                            type="text"
                            className="form__input form__input--sm"
                            id="billingPhoneNumber"
                            name="billingPhoneNumber"
                            placeholder="Contact Number"
                            maxLength={10}
                            onKeyDown={(event) => {
                              if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'ArrowUp' && event.key !== 'Tab') {
                                event.preventDefault();
                              }
                            }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={sameAsHomeAddress}
                            value={sameAsHomeAddress ? (values.billingPhoneNumber = patientDetails?.contactInfo?.mobileNo) : values.billingPhoneNumber}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='formCol'>
                      <div className="form__Field">
                        <label className="form__label" htmlFor='whatsappNumber'>Whatsapp Number</label>
                        <div className="form__groupField form__groupField--phonenumber">
                          <select
                            className="form__select form__select--sm"
                            style={customStyle.select}
                            id="billingWhatsappNumberCountryCode"
                            onChange={handleCountryCodeChange}
                            disabled={sameAsPhoneNo || sameAsHomeAddress}
                            value={values.billingWhatsappNumberCountryCode}
                          >
                            {commonData?.countryCode?.map((option) => (
                              <option
                                key={option}
                                value={option}
                                disabled={billingGeneralSettingsData?.status === 'success' && option !== selectedCountryCode}
                              >
                                {option}
                              </option>
                            ))}
                          </select>
                          <input
                            type="text"
                            className="form__input form__input--sm"
                            id="billingWhatsappNumber"
                            name="billingWhatsappNumber"
                            placeholder="Whatsapp Number"
                            onChange={handleChange}
                            disabled={sameAsPhoneNo || sameAsHomeAddress}
                            maxLength={10}
                            max={10}
                            onKeyDown={(event) => {
                              if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'ArrowUp' && event.key !== 'Tab') {
                                event.preventDefault();
                              }
                            }}
                            onBlur={handleBlur}
                            value={
                              sameAsPhoneNo
                                ? (values.billingWhatsappNumber = values.billingPhoneNumber)
                                : values.billingWhatsappNumber ||
                                (sameAsHomeAddress ? (values.billingWhatsappNumber = patientDetails?.contactInfo?.whatsappNo) : values.billingWhatsappNumber)
                            }
                          />
                        </div>
                        <div className="form__checkboxSubField">
                          <div className="form__checkbox">
                            <div className="form__checkbox__option m_0">
                              <input
                                className="form__checkbox__input"
                                id='sameAsContact'
                                disabled={sameAsHomeAddress}
                                checked={sameAsPhoneNo}
                                type="checkbox"
                                name="sameAsContact"
                                value="sameAsContact"
                                onChange={(e) => {
                                  setSameAsPhoneNo(!sameAsPhoneNo);
                                  if (sameAsPhoneNo) {
                                    values.billingWhatsappNumber = '';
                                    countryCode.billingWhatsappNumberCountryCode = selectedCountryCode;
                                  }
                                }}
                              />
                              <label htmlFor="sameAsContact" className="form__checkbox__label"> Same as Contact Number</label>
                            </div>
                          </div>
                        </div>
                        <ErrorMessage name="whatsappNumber" component="div" className="error text-error" />
                      </div>
                    </div>
                  </div>
                  <div className='formRow formRow__4'>
                    <div className='formCol'>
                      <div className="form__Field">
                        <label className="form__label" htmlFor='referringDoctorSpeciality'>
                          Zip Code
                        </label>
                        <input
                          className="form__input form__input--sm"
                          type="text"
                          id="billingZipCode"
                          name="billingZipCode"
                          placeholder="Zip Code"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={sameAsHomeAddress}
                          value={
                            sameAsHomeAddress ? (values.billingZipCode = patientDetails?.contactInfo?.zipCode) : values.billingZipCode
                          }
                        />
                      </div>
                    </div>
                    <div className='formCol'>
                      <div className="form__Field">
                        <label className="form__label">
                          Country
                        </label>
                        <select
                          className="form__select form__select--sm"
                          id="billingCountry"
                          name="billingCountry"
                          style={customStyle.select}
                          onChange={(e) => {
                            handleChange(e);
                            fetchStates(e.target.value, '', 'state');
                          }}
                          disabled={sameAsHomeAddress}
                          onBlur={handleBlur}
                          value={
                            sameAsHomeAddress ? (values.billingCountry = patientDetails?.contactInfo?.country) : values.billingCountry
                          }
                        >
                          <option value="">-Select-</option>
                          {commonData?.countryList?.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className='formCol'>
                      <div className="form__Field">
                        <label className="form__label">
                          State
                        </label>
                        <select
                          className="form__select form__select--sm"
                          id="billingState"
                          name="billingState"
                          style={customStyle.select}
                          onChange={(e) => {
                            handleChange(e);
                            fetchStates(values.billingCountry, e.target.value, 'city');
                          }}
                          onBlur={handleBlur}
                          disabled={sameAsHomeAddress}
                          aria-label={sameAsHomeAddress && 'billingState'}
                          value={
                            sameAsHomeAddress ? (values.billingState = patientDetails?.contactInfo?.state) : values.billingState
                          }
                        >
                          {sameAsHomeAddress ? (
                            <option selected value={patientDetails?.contactInfo?.state}>{patientDetails?.contactInfo?.state}</option>
                          ) : (
                            <option value="">-Select-</option>
                          )}
                          {state?.map((option) => (
                            <option key={option.isoCode} value={option.isoCode}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="form__Field">
                      <label className="form__label">
                        City
                      </label>
                      <select
                        className="form__select form__select--sm"
                        id="billingCity"
                        name="billingCity"
                        style={customStyle.select}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={sameAsHomeAddress}
                        value={
                          sameAsHomeAddress ? (values.billingCity = patientDetails?.contactInfo?.city) : values.billingCity
                        }
                      >
                        {sameAsHomeAddress ? (
                          <option selected value={patientDetails?.contactInfo?.city}>{patientDetails?.contactInfo?.city}</option>
                        ) : (
                          <option value="">-Select-</option>
                        )}
                        {cities?.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="formRow formRow__4">
                    <div className='formCol'>
                      <div className="form__Field">
                        <label className="form__label" htmlFor='billingAlternateNumberCountryCode'>
                          Alternate Number
                        </label>
                        <div className='form__groupField form__groupField--phonenumber'>
                          <select
                            className="form__select form__select--sm"
                            style={customStyle.select}
                            id="billingAlternateNumberCountryCode"
                            onChange={handleCountryCodeChange}
                            disabled={sameAsHomeAddress}
                            value={values.billingAlternateNumberCountryCode}
                          >
                            {commonData?.countryCode?.map((option) => (
                              <option
                                key={option}
                                value={option}
                                disabled={billingGeneralSettingsData?.status === 'success' && option !== selectedCountryCode}
                              >
                                {option}
                              </option>
                            ))}
                          </select>
                          <input
                            type="text"
                            className="form__input form__input--sm"
                            id="billingAlternateNumber"
                            name="billingAlternateNumber"
                            placeholder="Alternate Number"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={sameAsHomeAddress}
                            maxLength={10}
                            max={10}
                            onKeyDown={(event) => {
                              if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'ArrowUp' && event.key !== 'Tab') {
                                event.preventDefault();
                              }
                            }}
                            value={sameAsHomeAddress ? (values.billingAlternateNumber = patientDetails?.contactInfo?.alternateMobileNo) : values.billingAlternateNumber}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {values.quesInfo.length > 0 && appointmentType === 'investigation_with_modality' && (
                  <section className="form__section">
                    <h1 className="form__section__title">Other Question*</h1>
                    <FieldArray name="quesInfo">
                      {({ remove, push }) => (
                        <>
                          {values.quesInfo.map((question, index) => (
                            <div className="flex items-center mt-5" key={question._id}>
                              <label className={`mr-4 w-1/3 ${isDarkMode?.isDarkMode ? "text-white" : "text-gray-700"}`}>
                                {question.question}
                              </label>
                              <div className="flex items-center">
                                {['true', 'false'].map((option) => (
                                  <label
                                    key={option}
                                    className="flex items-center mr-8 custom-radio-container"
                                  >
                                    <Field
                                      type="radio"
                                      name={`quesInfo.${index}.answer`}
                                      value={option}
                                      checked={values.quesInfo[index]?.answer === option}
                                      onChange={() => {
                                        setFieldValue(`quesInfo.${index}.answer`, option);
                                      }}
                                      className="form-radio text-indigo-600"
                                    />
                                    <span className="custom-radio"></span>
                                    <span className={`mL-2 ${isDarkMode?.isDarkMode ? "text-white" : "text-gray-700"}`}>
                                      {option === 'true' ? 'Yes' : 'No'}
                                    </span>
                                  </label>
                                ))}
                              </div>
                              {errors.quesInfo?.[index]?.answer && touched.quesInfo?.[index]?.answer && (
                                <div className="text-red-500 text-sm">
                                  {errors.quesInfo[index].answer}
                                </div>
                              )}
                            </div>
                          ))}
                        </>
                      )}
                    </FieldArray>
                  </section>
                )}

                <section className='form__section'>
                  <div className='btn__group'>
                    <button
                      className='btn btn__white'
                      onClick={() => {
                        resetForm();
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className='btn btn__primary'
                      type="submit"
                    >
                      Book Appointment
                    </button>
                  </div>
                </section>
              </Form>
            )
          }}
        </Formik>
      </div>
      <SuccessModal
        isSuccessModalOpen={modal}
        title={title}
        handleCloseModal={() => setModal(false)}
      />
      <Loader
        isLoaderOpen={loading || appLoading}
      />
    </>

  )

}

export default NewAppointment
